import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactRoutePropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import SmartCard from '../../../shared/components/SmartCard';
import {
  communicationAnalysisSaveMutation,
  communicationFindByIdQuery,
} from '../../../shared/queries/Communication';
import PeriodicAnalysis from './Form';
import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { studentListWithClassesNamesByFilter } from '../../../shared/queries/Student';
import { updatePendency } from '../../../shared/utils/smartutils';
import { analysisItemListByFilter } from '../../../shared/queries/PeriodicAnalysis';

const PeriodicAnalysisFormHandler = (props) => {
  const { match, t, history, dispatch, foreignToggleClose } = props;
  const [dto, setDto] = useState({
    id: 0,
    date: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      new Date().getHours() + 1,
      0,
      0
    ),
    sent: false,
  });
  const [formOn, setFormOn] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [analysisItems, setAnalysisItems] = useState([]);

  function onBackClick() {
    if (foreignToggleClose) {
      foreignToggleClose();
    } else {
      history.push('/minime/analise');
    }
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function loadAllStudents() {
    const filter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyWithAccess: true,
      onlyActive: true,
    };

    const query = studentListWithClassesNamesByFilter(filter);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.studentListByFilter = res.studentListByFilter.map((item) => ({
          ...item,
          value: String(item.value),
        }));
        setStudentList(res.studentListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  }

  function getAnalysisItems(data) {
    return data.map((item) => ({
      ...item,
      id: item.analysisItem.id,
    }));
  }

  function findById(id) {
    showLoading();
    const query = communicationFindByIdQuery(id);
    GraphQL(query, {})
      .then((res) => {
        const communication = { ...res.communicationListByFilter[0] };
        const updatedDto = {
          ...communication,
          date: new Date(communication.createdAtMili),
          relatedObjects: {
            ...communication.relatedObjects[0],
            value: communication.relatedObjects[0].id,
            label: communication.relatedObjects[0].description,
          },
          analysisItems: getAnalysisItems(communication.analysisItems),
        };
        if (!updatedDto.editable) {
          showNotificationAutoDestroy(
            'warning',
            t('notifications.attention'),
            t('notifications.cant-be-edited-anymore')
          );
        }
        setDto(updatedDto);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  function handleSubmit(values) {
    showLoading();
    const mutation = communicationAnalysisSaveMutation(values, false);
    GraphQL(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        onBackClick();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
        updatePendency(dispatch);
      });
  }

  function loadAnalysisItems() {
    showLoading();
    const filter = {
      id: 0,
      order: 0,
      updaterId: 0,
      active: true,
      filterByStatus: true,
    };
    const query = analysisItemListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.analysisItemListByFilter) {
          res.analysisItemListByFilter = res.analysisItemListByFilter.map(
            (item) => ({
              ...item,
              analysisName: item.name,
            })
          );
          setAnalysisItems(res.analysisItemListByFilter);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => {
    loadAllStudents();
  }, []);

  return (
    <SmartCard title={t('panels.periodic-analysis')}>
      {formOn && (
        <PeriodicAnalysis
          onSubmit={handleSubmit}
          backHandler={onBackClick}
          studentList={studentList}
          dto={dto}
          analysisItems={analysisItems}
          setAnalysisItems={setAnalysisItems}
          loadAnalysisItems={loadAnalysisItems}
        />
      )}
    </SmartCard>
  );
};

PeriodicAnalysisFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRoutePropTypes.history.isRequired,
  match: ReactRoutePropTypes.match.isRequired,
  foreignToggleClose: PropTypes.func,
};

PeriodicAnalysisFormHandler.defaultProps = {
  foreignToggleClose: undefined,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(PeriodicAnalysisFormHandler)
);
